
/**
 * 응답 데이터
 */
export type NicePayCallbackResponseData = { [key: string]: unknown };
